module.exports = __webpack_public_path__ + "static/media/pawritten-bold.3fbc8619.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten-bold.svg
// module id = ./src/assets/fonts/pawritten-bold.svg
// module chunks = 6